import AppStorageService from "./app-storage.service";

class TachographSessionService {
  buildState(source = {}) {
    return {
      selectedVehicle: source.selectedVehicle ?? null,
      currentDay: source.currentDay ?? null,
      currentActivity: source.currentActivity ?? 0,
      currentActivityStart: source.currentActivityStart ?? 0,
      swBegin: source.swBegin ?? null,
      counter: Array.isArray(source.counter) ? source.counter : [],
      calculatedDistance: Number(source.calculatedDistance ?? 0),
      startKm: Number(source.startKm ?? 0),
      bufferedActivity: source.bufferedActivity || "",
      bufferedPosition: source.bufferedPosition || "",
      bufferedVehicle: source.bufferedVehicle || "",
    };
  }

  saveState(source) {
    return AppStorageService.setDay(this.buildState(source));
  }

  loadState() {
    const storedState = AppStorageService.getDay();
    if (!storedState) {
      return null;
    }

    const normalizedState = this.buildState(storedState);
    return {
      ...normalizedState,
      swBegin: normalizedState.swBegin ? new Date(normalizedState.swBegin) : null,
    };
  }

  clearState() {
    AppStorageService.clearDay();
  }

  getCurrentDay() {
    return this.loadState()?.currentDay ?? null;
  }

  getSelectedVehicle() {
    return this.loadState()?.selectedVehicle ?? null;
  }

  hasStoredDay() {
    return !!this.getCurrentDay();
  }

  isSameCalendarDay(dayValue, referenceDate = new Date()) {
    if (!dayValue) {
      return false;
    }

    const parsedDay = new Date(dayValue);
    if (Number.isNaN(parsedDay.getTime())) {
      return false;
    }

    return new Date(parsedDay.toDateString()).getTime() === new Date(referenceDate.toDateString()).getTime();
  }
}

export default new TachographSessionService();
